// Turkish
export const locale = {
  global: {
    create: 'Oluştur',
    ok: 'Tamam',
    previous: 'Önceki',
    nextStep: 'Sonraki Adım',
    createDate: 'Oluşturma Tarihi',
    category: 'Kategori',
    hello: 'Merhaba',
    languageSelection: 'Dil Seçimi',
    language: 'Dil',
    search: 'Ara',
    addNew: 'Yeni Ekle',
    save: 'Kaydet',
    cancel: 'Vazgeç',
    close: 'Kapat',
    noData: 'Data bulunamadı',
    loadingItems: 'Yükleniyor...',
    copied: 'Kopyalandı',
    select: 'Seç',
    clear: 'Temizle',
    actions: 'işlemler',
    events: 'Etkinlikler',
    notifications: 'Bildirimler',
    makeRead: 'Okundu yap',
    deleteAll: 'Tümünü sil',
    noNotificationToDisplay: 'Gösterilecek bildirim bulunamadı.',
    informations: 'Bilgiler',
    pleaseSelect: 'Lütfen seçin',
    features: 'Özellikler',
    isActive: 'Aktif mi?',
    name: 'Ad',
    surname: 'Soyad',
    type: 'Tip',
    totalDisk: 'Toplam Disk',
    totalDiskMB: 'Toplam Disk (MB)',
    userDisk: 'Kullanıcı Diski',
    userDiskMB: 'Kullanıcı Diski (MB)',
    isReadonly: 'Salt Okunur?',
    diskPhysicalType: 'Disk Fiziksel Türü',
    diskType: 'Disk Tipi',
    size: 'Boyut',
    sizeMb: 'Boyut (MB)',
    isAttached: 'Eklenmiş mi?',
    yes: 'Evet',
    no: 'Hayır',
    ipAddress: 'IP Adresi',
    version: 'Versiyon',
    os: 'İşletim Sistemi',
    perGB: 'GB Başına',
    services: 'Hizmetler',
    networking: 'Ağ İletişimi',
    serviceName: 'Servis Adı',
    isPublic: 'Herkese Açık mı?',
    country: 'Ülke',
    city: 'Şehir',
    manage: 'Yönet',
    roleUpdated: 'Rol Güncellendi!',
    successful: 'İşleminiz başarıyla tamamlandı!',
    createVirtualMachineSuccessful:
      'İşleminiz başarıyla tamamlandı, Sanal Makine birazdan oluşturulacak.',
    anErrorHasOccurred:
      'Bir hata oluştu, lütfen daha sonra tekrar deneyin veya yöneticinize başvurun.!',
    destinationIp: 'Hedef Ip',
    destinationPort: 'Hedef Port',
    price: 'Fiyat',
    pricePerGb: 'Fiyat (GB Başına)',
    contractPrice: 'Sözleşme Fiyatı',
    selectedDiskSize: 'Seçili disk boyutu',
    roleRemoved: 'Role Silindi!',
    remove: 'Kaldır',
    pleaseConfirm: 'Lütfen Onaylayın',
    doYouWantToContinueProcessing: 'İşleme devam etmek istiyor musunuz?',
    areYouSure: 'Emin misiniz? Geri dönüş yok!',
    solveQuestion:
      'İşlemi tamamlamak için aşağıdaki işlemi çözün ve onayla butonuna basın',
    confirm: 'Onayla',
    confirmed: 'Onaylandı',
    whatIsTheSum: '{0} toplamı nedir?',
    writeTheAnswer: 'Cevabı yazınız',
    detail: 'Detay',
    success: 'Başarılı',
    error: 'Hata',
    isAvaible: 'Mevcut mu ?',
    device: 'Cihaz',
    update: 'Güncelle',
    execute: 'Execute',
    unknown: 'Bilinmiyor',
    public: 'Herkese Açık',
    private: 'Gizli',
    hostname: 'Hostname',
    cpuCores: 'CPU Cores',
    ram: 'Ram',
    ramMB: 'Ram (MB)',
    usedCpu: 'Kullanılan CPU',
    usedRam: 'Kullanılan RAM',
    usedDisk: 'Kullanılan Disk',
    usedDiskMB: 'Kullanılan Disk (MB)',
    isAlive: 'Yaşıyor mu?',
    vlan: 'VLAN',
    subnet: 'Subnet',
    changeName: 'Adı Değiştir',
    tagPool: 'Tag Pool',
    auto: 'Otomatik',
    minutes: '{0} Dakika',
    hours: '{0} Saat',
    days: '{0} Gün',
    hourlyPrice: 'Saatlik Ücret',
    subdomain: 'Alt Alan Adı',
    status: 'Durum',
    openDetail: 'Detay Aç',
    continues: 'Devam ediyor',
    selectProductCatalogList: 'Ürün Katalog Listesini Seçin',
    selectFromList: 'Listeden Seç',
    month: '{0} Ay',
    year: '{0} Yıl',
    doYouWantToDelete: 'Silmek istiyor musunuz?',
    successfullyRemoved: 'Başarıyla kaldırıldı',
    delete: 'Sil',
    description: 'Tanım',
    general: 'Genel',
    list: 'Liste',
    advanced: 'Gelişmiş',
    and: 've',
    send: 'Gönder',
    lock: 'Kilit',
    connectedTo: 'Kime bağlı',
    state: 'Durum',
    service: 'Service',
    protocol: 'Protocol',
    priority: 'Öncelik',
    weight: 'Weight',
    port: 'Port',
    target: 'Target',
    refresh: 'Yenile',
    generateStrongPassword: 'Güçlü Şifre Oluştur',
    stash: 'Stash',
    subscription: 'Abonelik',
    currency: 'Para Birimi',
    value: 'Değer',
    maxBandwidth: 'Maks Bant Genişliği',
    cpu: 'CPU',
    hardDisk: 'Hard Disk',
    domain: 'Domain',
    id: 'ID',
    ipSubnet: 'IP / Subnet',
    bandWidthMaxBW: 'Bant Genişliği / Maks BG',
    electricity: 'Elektrik',
    generators: 'Jeneratör',
    tierLevel: 'Katman',
    isEdge: 'Edge',
    configurations: 'Yapılandırma',
    more: 'Devamı',
    createStorageMembers: 'Storage Members Oluştur',
    configurations: 'Yapılandırma',
    more: 'Devamı',
    ipV4: 'IP v4',
    ipV6: 'IP v6',
    true: 'Evet',
    false: 'Hayır',
    username: 'Kullanıcı Adı',
    password: 'Şifre',
    newPassword: 'Yeni şifre',
    passwordConfirmation: 'Şifre onaylama',
    passwordOperations: 'Şifre işlemleri',
    hash: 'Şifreleme',
    cpuType: 'CPU Tipi',
    extra: 'Ekstra',
    distro: 'Dağıtım',
    imagesPath: 'Resim Yolu',
    isoPath: 'ISO Yolu',
    path: 'Yol',
    replicas: 'Replicas',
    image: 'Image',
    receivingPort: 'Receiving Port',
    distributingPort: 'Distributing Port',
    enableService: 'Hizmeti Etkinleştir',
    networkType: 'Network Tipi',
    gateway: 'Gateway',
    ipAddressRangeStart: 'IP Adresi Aralık Başlangıcı',
    ipAddressRangeEnd: 'IP Adresi Aralık Bitişi',
    account: 'Hesabım',
    community: 'Topluluk',
    team: 'Takım',
    url: 'URL',
    email: 'Email',
    groupName: 'Grup Adı',
    userpassword: 'Kullanıcı Şifresi',
    member: 'Üyeler',
    enterMemberInfo: 'Üye bilgisi girin',
    addMember: 'Üye Ekle',
    basic: 'Temel',
    preferences: 'Tercihler',
    currentPassword: 'Güncel Şifre',
    title: 'Başlık',
    verificationCode: 'Doğrulama Kodu',
    location: 'Lokasyon',
    page404: 'Sayfa bulunamadı',
    pageCallback: 'Callback',
    login: 'Giriş',
  },
  auth: {
    welcome: "Plusclouds'a Hoşgeldiniz",
    newHere: 'Yeni Misin?',
    createAnAccount: 'Kayıt Ol',
    loginWith: 'PlusClouds ile Giriş Yap',
    redirectMessage:
      "Lütfen bekleyin, {0} Console'a geri yönlendiriliyorsunuz.",
    signOut: 'Çıkış Yap',
    youNeedToLogInToContinue:
      'İşleminize devam edebilmeniz için tekrar giriş yapmanız gerekmektedir.',
  },
  dashboard: {
    dashboard: 'Anasayfa',
    followOnYoutube: "Youtube'da bizi takip edin!",
    youtubeInfoLine1:
      'Sunucularımızda kimseye ihtiyaç duymadan yeni diskler oluşturabileceğinizi, barındırdığınız diskleri veya aldığınız hizmetleri yönetebileceğinizi ve tüm bu işlemleri birkaç tıkla gerçekleştirebileceğinizi biliyor muydunuz?',
    youtubeInfoLine2:
      '"Leo Panel\'e nasıl giriş yapılır", "Sanal makine kurulumu nasıl yapılır?", "Yeni Ağ nasıl oluşturulur", "Yeni disk kalıbı ekleme" ve bunlara benzer daha birçok videoyu <a href="https://www.youtube.com/playlist?list=PLsL_qghN-mdGMYtQcUTAvxhQCpRVcebCU" class="font-weight-bold" target="_blank">LEO Panel Kullanım Kılavuzu</a> listemizden takip edebilirsiniz.',
    goDNSService: 'DNS Hizmetine Git',
    dnsInfoLine1:
      '<a href="/networking/domain-name-service" class="text-primary opacity-75-hover">DNS Servisi</a>mizi denemiş miydiniz?',
    dnsInfoLine2:
      'Eğer "DNS Nedir?" diyorsanız, sizi <a href="https://plusclouds.com.tr/blog/dns-nedir" target="_blank" class="text-muted">blogumuza</a> bekliyoruz.',
    joinUsDiscord: "Discord'da bize katıl",
    resourceUsage: 'Kaynak Kullanımı',
    readTheArticle: 'Yazıyı Oku',
    goToBlog: "Blog'a Git",
  },
  pagination: {
    goToPage: 'Sayfaya git',
    totalRecord: 'Toplam Kayıt',
  },
  filters: {
    filters: 'Filtreler',
    all: 'Tümü',
    allPriorities: 'Tüm Öncelikler',
    allCategories: 'Tüm Kategoriler',
    low: 'Düşük',
    medium: 'Orta',
    high: 'Yüksek',
    windows: 'Microsoft® Windows',
    linux: 'Linux',
    allTypes: 'Tüm Tipler',
    running: 'Çalışıyor',
    halted: 'Durduruldu',
    paused: 'Duraklatıldı',
    preparing: 'Hazırlanıyor',
    showAll: 'Tümünü Göster',
    active: 'Aktif',
    configuring: 'Yapılandırılıyor',
    inactive: 'Pasif',
    scheduled: 'Planlanmış',
    onlyEnabled: 'Sadece Aktifler',
    done: 'Tamamlanmış',
    idDesc: "Id'ye göre azalan",
    idAsc: "Id'ye göre artan",
    nameDesc: 'İsme göre azalan',
    nameAsc: 'İsme göre artan',
    open: 'Açık',
    pending: 'Bekliyor',
    closed: 'Kapalı',
  },
  servers: {
    servers: 'Sunucular',
    compute: 'Sunucular',
    vm: 'Sanal Makineler',
    vmDetail: 'Sanal Makine Detayı',
    newVM: 'Yeni Sanal Makine',
    searchVM: 'Sanal Makine ara',
    vd: 'Sanal Diskler',
    vdImage: 'Sanal Disk Kalıpları',
    plusCloudsCs: 'PlusClouds CS',
    plusCloudsCsDetail: 'PlusClouds CS Detay',
    newVD: 'Yeni Disk Kalıbı',
    newPlusCloudsCs: 'Create PlusClouds CS',
    searchForVD: 'Disk Kalıbı Ara',
    searchForPlusCloudsCs: 'Search for PlusClouds CS',
    attachedNotFound: 'Ek bulunamadı',
    notAttached: 'Eklenmemiş',
    attachedTo: 'Ekli:',
    vnc: 'Sanal Ağ Kartları',
    newVNC: 'Sanal Ağ Kartı Oluştur',
    searchForVNC: 'Sanal Ağ Kartı Ara',
    macAddress: 'Mac Adresi',
    network: 'Ağ',
    bandwidth: 'Bant genişliği',
    bandwidthMbit: 'Bant genişliği (Mbit)',
    ipManagement: 'IP Yönetimi',
    newIP: 'Yeni IP',
    searchForIP: 'IP Ara',
    networkName: 'Network Adı',
    templates: 'Şablonlar',
    templateDetail: 'Şablon Detayı',
    newTemplate: 'Şablon Oluştur',
    searchForTemplate: 'Şablon Ara',
    templateName: 'Şablon adı',
    selectTemplate: 'Şablon seçin',
    distribution: 'Dağıtım',
    baseRam: 'Temel RAM',
    baseDisk: 'Temel Disk',
    baseRamGb: 'Temel RAM (GB)',
    baseDiskGb: 'Temel Disk (GB)',
    virtualZones: 'Sanal Bölgeler',
    searchForNetworks: 'Ağları Ara',
    newNetwork: 'Ağ Oluştur',
    trafficCost: 'Trafik Maliyeti',
    dnsManagement: 'Alan Adı Hizmetleri Yönetimi',
    newDomain: 'Alan adı oluştur',
    searchForDomain: 'Alan Adı Ara',
    domainName: 'Alan Adı',
    runningUnderService: 'Hangi Hizmet Altında Çalıştırılıyor',
    ansible: 'Red Hat® Ansible',
    ansibleDetail: 'Red Hat® Ansible Detayı',
    playbooks: 'Playbooks',
    procedures: 'Prosedürler',
    executionsList: 'Yürütme Listesi',
    createRedHatAnsiblePlaybook: 'Red Hat® Ansible Playbook Oluştur',
    playbookName: 'Playbook Adı',
    roleCount: 'Rol Sayısı',
    roleName: 'Rol Adı',
    lastExecutionTime: 'Son Çalışma Zamanı',
    executionTotalTime: 'Yürütme Toplam Süresi',
    resultOk: 'Sonuç Tamam',
    resultChanged: 'Sonuç Değiştirildi',
    resultUnreachable: 'Sonuç Ulaşılamaz',
    resultFailed: 'Sonuç Başarısız',
    resultSkipped: 'Sonuç Atlandı',
    resultRescued: 'Sonuç Kurtarıldı',
    resultIgnored: 'Sonuç Yoksayıldı',
    ok: 'Tamam',
    changed: 'Değiştirildi',
    unreachable: 'Ulaşılamaz',
    failed: 'Başarısız',
    skipped: 'Atlandı',
    rescued: 'Kurtarıldı',
    ignored: 'Yoksayıldı',
    time: 'Zaman',
    createProxyRule: 'Proxy Kuralı Oluştur',
    proxyManagement: 'Proxy Yönetimi',
    serverName: 'Sunucu Adı',
    sourceIP: 'Kaynak Ip',
    sourcePort: 'Kaynak Port',
    destinationIP: 'Hedef Ip',
    destinationPort: 'Hedef Port',
    createNatRule: 'NAT Kuralı Oluştur',
    natManagement: 'NAT (Ağ Adresi Çevirisi) Yönetimi',
    messageQueuing: 'Mesaj Kuyruğu',
    createMessageQueue: 'Mesaj Kuyruğu Oluştur',
    searchForMessageQueuing: 'Mesaj Kuyruğunda Ara',
    databaseService: 'Veritabanı Servisi',
    databaseType: 'Veritabanı Tipi',
    databaseVersion: 'Veritabanı Versiyonu',
    createDatabaseService: 'Veritabanı Servisi Oluştur',
    searchForDatabase: 'Veritabanı ara',
    createCloudNode: 'Cloud Node Oluştur',
    cloudNodes: 'Bulut (Veri Merkezi) Node',
    cloudNode: 'Bulut Node',
    cloudNodeDetail: 'Bulut Node Detayı',
    storagePoolsDetail: 'Depolama Havuzları Detayı',
    datacenter: 'Veri Merkezi',
    cloudVendor: 'Bulut Satıcısı',
    pricingModel: 'Fiyatlandırma Modeli',
    myCloud: 'Bulut',
    computeManagement: 'Compute Management',
    computeMembers: 'Compute Members',
    computePools: 'Hesaplama Havuzu',
    searchForComputePools: 'Hesaplama Havuzu Ara',
    computePoolName: 'Hesaplama Adı',
    changePoolPassword: 'Hesaplama Şifresini Değiştir',
    virtualization: 'Sanallaştırma',
    poolType: 'Havuz Tipi',
    storagePools: 'Depolama Havuzları',
    searchForStoragePools: 'Depolama Havuzlarını Ara',
    networkPools: 'Ağ Havuzları',
    searchForNetworkPools: 'Ağ Havuzlarını Ara',
    storage: 'Depolama',
    renameDisk: 'Diski yeniden adlandır',
    attachToAServer: 'Sunucuya bağla',
    detachFromServer: 'Sunucudan ayır',
    changeDiskSize: 'Disk boyutunu değiştir',
    cloneDisk: 'Disk kopyala',
    terminate: 'Sonlandır',
    terminateDomain: 'Domaini Sonlandır',
    renameNetworkCard: 'Network kartını yeniden adlandır',
    changeMacAddress: 'Mac adresi değiştir',
    attachIPv4: 'IPv4 bağla',
    detachIPv4: 'IPv4 ayır',
    assignRandomIP: 'Rasgele IP ata',
    assignRandomIPv4: 'Rasgele IPv4 ata',
    attachToANetworkCard: 'Ağ kartına bağla',
    detachFromANetworkCard: 'Ağ kartından ayır',
    removeReservation: 'Rezervasyonu kaldır',
    reservation: 'Rezerve Et',
    selectedReservationIP: 'Seçtiğiniz IP Adresi rezerve edilecektir.',
    disableNATRule: 'NAT kuralını pasifleştir',
    enableNATRule: 'NAT kuralını aktifleştir',
    deleteNATRule: 'NAT kuralını sil',
    executeOnDevice: 'Cihazda çalıştır',
    executeOnVirtualMachine: 'Sanal makinede çalıştır',
    renamePlaybook: 'Playbook adı değiştir',
    proxyService: 'Proxy Servisi',
    natService: 'NAT Servisi',
    dnsService: 'DNS Servisi',
    reserveIP: "Ip'yi rezerve et",
    networkCardName: 'Ağ Kartı Adı',
    enterNetworkCardName: 'Ağ kartı adını girin',
    enterNetworkName: 'Network adını girin',
    convertToTemplate: 'Şablona dönüştür',
    updateVMName: 'Sanal makine adını güncelle',
    vmName: 'Sanal makine adı',
    enterVmName: 'Sanal makine adını girin',
    updateHostName: 'Hostname güncelle',
    hostName: 'Hostname',
    enterHostName: 'Hostname girin',
    overrideUsername: 'Kullanıcı adını geçersiz kıl',
    overridePassword: 'Parolayı geçersiz kıl',
    lockDynamicChanges: 'Dinamik değişiklikleri kilitle',
    unlockDynamicChanges: 'Dinamik değişikliklerin kilidini aç',
    takeSnapshot: 'Anlık Görüntü Al',
    vmMustBeHalted: 'Bu işlem için sanal makine durdurulmalıdır.',
    enterDistribution: 'Dağıtımı girin',
    operatingSystem: 'İşletim Sistemi',
    enterOperatingSystem: 'İşletim sistemini girin',
    distributionVersion: 'Dağıtım Sürümü',
    enterDistributionVersion: 'Dağıtım sürümünü girin',
    username: 'Kullanıcı adı',
    enterUsername: 'Kullanıcı adını girin',
    password: 'Şifre',
    enterPassword: 'Şifre girin',
    passwordConfirmation: 'Şifre onaylama',
    enterPasswordConfirmation: 'Şifrenizi tekrar girin',
    newPassword: 'Yeni şifre',
    snapshotName: 'Anlık Görüntü Adı',
    enterSnapshotName: 'Anlık görüntü adını girin',
    snapshotInfo:
      'Anlık görüntü almak sabit disk alanını kullanır. Aşağıdaki fiyat tahmini, anlık görüntü aldığınız saate ve faturalandırma döngünüzün sonuna göre hesaplanır.',
    unlockDynamicInfo:
      'Bu sanal makinenin kilidini açarak bazı işlemlerde <b>etkinleştireceksiniz</b>. Örneğin;<ul><li>Kaynakları değiştirebilirsiniz</li><li>Bu makineyi yeniden başlatabilirsiniz</li><li>Bu makineyi kapatabilirsiniz</li><li>Bu makinenin fişini çekebilirsiniz</li><li>Bu makineyi kopyalayabilirsiniz</li><li>Bu makineyi sonlandırabilirsiniz</li></ul>',
    lockDynamicInfo:
      'Bu sanal makineyi kilitleyerek bazı eylemlerde <b>sınırlı olacaksınız</b>. Örneğin;<ul><li>Kaynakları değiştiremezsiniz</li><li>Bu makineyi yeniden başlatamazsınız</li><li>Bu makineyi kapatamazsınız</li><li>Bu makinenin fişini çekemezsiniz</li><li>Bu makineyi kopyalayamazsınız</li><li>Bu makineyi sonlandıramazsınız</li></ul>',
    tagServer: 'Etiket Sunucusu',
    selectTag: 'Etiket Seç',
    renameNetworkCard: 'Ağ kartını yeniden adlandır',
    changeMacAddress: 'Mac adresi değiştir',
    deviceNumber: 'Cihaz Numarası',
    randomIPWillBeGenerated: 'Rastgele IP adresi oluşturulacaktır.',
    diskName: 'Disk Adı',
    enterDiskName: 'Disk adı girin',
    changeSizeInfo:
      'Şimdi disk görüntü boyutunu değiştiriyorsunuz. Lütfen disk boyutunu dahili olarak artırdığınızdan veya boş alanı yeni bir birim olarak eklediğinizden emin olun.',
    numberOfCores: 'Çekirdek sayısı',
    memorySize: 'Bellek boyutu',
    cpuUpdatedSuccessfully: 'CPU başarıyla güncellendi.',
    ramUpdatedSuccessfully: 'RAM başarıyla güncellendi.',
    incomingIP: 'Gelen IP',
    incomingPort: 'Gelen Port',
    outgoingIP: 'Giden IP',
    outgoingPort: 'Giden Port',
    recordType: 'Kayıt Tipi',
    record: 'Kayıt',
    recordSubdomain: 'Kayıt / Alt alan adı',
    content: 'İçerik',
    contentValue: 'Content / Value',
    updateContent: 'İçerik güncelle',
    updateTTL: 'TTL güncelle',
    createAttachNetworkCard: 'Ağ Kartı Oluştur ve Ekle',
    createAttachDiskImages: 'Disk Görüntüsü Oluştur & Ekle',
    attachExistingDiskImages: 'Mevcut Disk Görüntülerini Ekle',
    selectDisk: 'Disk Seç',
    advancedDns: 'Gelişmiş DNS',
    natGateways: 'NAT Gateways',
    proxyGateways: 'Proxy Gateways',
    addRecord: 'Kayıt Ekle',
    ttl: 'TTL',
    streamName: 'Yayın Adı',
    streamingDate: 'Yayın Tarihi',
    streaming: 'Yayın',
    streamingDetail: 'Yayın Detayı',
    searchForStreams: 'Yayın ara',
    createNewStream: 'Yeni Yayın Oluştur',
    streamPreview: 'Yayın Önizlemesi',
    streamInfo:
      "Lütfen yayın URL'sini ve yayın anahtarını kullanarak yayını yayınlayın.",
    addNewPublishLink: 'Yeni Yayınlama Bağlantısı Ekle',
    releaseInformation: 'Yayın Bilgileri',
    broadcastQuality: 'Yayın Kalitesi',
    broadcastStartTime: 'Yayın Başlama Zamanı',
    releaseTime: 'Yayın Süresi',
    broadcastEndTime: 'Yayın Bitiş Zamanı',
    copyEmbedCode: 'Gömme Kodu Kopyala',
    streamInformation: 'Stream Bilgileri',
    streamKey: 'Yayın Anahtarı',
    streamUrl: 'Yayın Url',
    streamUrlPlaceholder: 'rtmp://1.1.1.1/LiveApp',
    publishUrl: 'Paylaşım Url',
    publicKey: 'Genel Anahtar',
    publishLinks: 'Paylaşım Linkleri',
    serviceType: 'Servis Tipi',
    incomingRouterIp: 'Gelen yönlendirici IP',
    streamingClusters: 'Yayın kümeleri',
    streamingClustersDetail: 'Yayın küme detayı',
    createCluster: 'Küme oluştur',
    updateCluster: 'Küme güncelle',
    createEdge: 'Edge oluştur',
    updateEdge: 'Edge güncelle',
    createOrigin: 'Origin oluştur',
    updateOrigin: 'Origin güncelle',
    createStream: 'Yayın oluştur',
    updateStream: 'Yayın güncelle',
    broadcastAnalysisInProgress: 'Yayın analizi yapılıyor...',
    dhcpServerName: 'DHCP Sunucu Adı',
    dhcpRecordCount: 'DHCP Kayıt Sayısı',
    dnsServerName: 'DNS Sunucu Adı',
    dnsRecordCount: 'DNS Kayıt Sayısı',
    natServerName: 'NAT Sunucu Adı',
    natRecordCount: 'NAT Kayıt Sayısı',
    proxyServerName: 'Proxy Sunucu Adı',
    proxyRecordCount: 'Proxy Kayıt Sayısı',
    natRules: 'NAT Kuralları',
    proxyRules: 'Proxy Kuralları',
    dnsDetail: 'DNS Detayı',
    enterComputeMembersForSearch: 'Arama için compute member adını girin',
  },
  detail: {
    goToConsole: "Konsol'a Git",
    stop: 'Durdur',
    start: 'Başlat',
    restart: 'Yeniden Başlat',
    plugUnplug: 'Fişi Çek ve Fişi Tak',
    unplug: 'Fişi Çek',
    serverOperations: 'Sunucu İşlemleri',
    tags: 'Etiketler',
    management: 'Yönetim',
    addTag: 'Etiket ekle..',
    searchForName: 'Ada Göre Ara',
    vm: {
      connectionInfo: 'Bağlantı Bilgisi',
      connectionPort: 'Bağlantı Portu',
      protocol: 'Protokol',
      username: 'Kullanıcı Adı',
      password: 'Şifre',
      lockingState: 'Kilit Durumu',
      machineType: 'Makine Tipi',
      unknown: 'Bilinmiyor',
      locked: 'Kilitli',
      unlocked: 'Kilitli Değil',
      selectVM: 'Sanal Makineyi Seç',
      enterVmNameForSearch: 'Arama için sanal makine adını girin',
      selectAttachIPv4: 'IPv4 eklemeyi seçin',
      enterIpForSearch: 'Arama için ip girin',
      selectDetachIPv4: 'Ayrılacak IPv4 seçin',
      detachIpv4Info: 'Ipv4 adresi bu ağ kartından ayrılacaktır.',
      youCannotShrinkAPackage: 'Paket küçültme işlemi yapamazsınız.',
      serverIsDown:
        'Sunucu kapalı olduğu için verileriniz görüntülenememektedir.',
    },
    cloudNode: {
      nodeType: 'Node Type',
      virtualization: 'Virtualization',
      virtualizationVersion: 'Virtualization Version',
      minCPULimit: 'Min CPU Limit',
      maxCPULimit: 'Max CPU Limit',
      minRAMLimit: 'Min RAM Limit',
      maxRAMLimit: 'Max RAM Limit',
      isPublic: 'Is Public?',
      isEdge: 'Is Edge?',
      startAutoDiscovery: 'Start Auto Discovery',
      setNodePublic: 'Set this node public',
      makePubliclyAvailable: 'Make publicly available',
      changeMaintenanceMode: 'Change Maintenance Mode',
      addServer: 'Add Server',
      addNetworkDevice: 'Add Network Device',
    },
    stash: {
      createArchiveNow: 'Hemen arşivini yarat',
      createAccount: '5 dakikada hesabını yarat ve hemen kullanmaya başla',
      allFileInfo:
        "Dosyalarınız hafızanızda eskimesin<br />Hepsini STASH'leyin",
      notCurrentlyStashProduct: 'Şu an Stash ürünümüzü kullanmıyorsunuz.',
      ifYouWishStartUsing:
        "Dilerseniz hemen Stash'ı kullanmaya başlayabilirsiniz.",
      getStartedNow: 'Hemen Kullanmaya Başla',
      username: 'Kullanıcı Adı',
      password: 'Şifre',
      details: 'Detaylar',
      basic: 'Temel',
      deleteYourAccount: 'Hesabınızı silin',
      lastUploads: 'Son Yüklemeler',
      name: 'İsim',
      dateCreated: 'Oluşturma Tarihi',
      lastEdit: 'Son Düzenleme',
      size: 'Boyut',
      storageUsage: 'Depolama Kullanımı',
      storageManagement: 'Depolama Yönetimi',
      lastActivities: 'Son Hareketler',
      users: 'Kullanıcılar',
      fullname: 'Adı Soyadı',
      status: 'Durum',
      active: 'Aktif',
      inactive: 'Pasif',
      quota: 'Kota',
      actions: 'İşlemler',
      createStashUser: 'Stash Kullanıcısı Oluştur',
      updateStashUser: 'Stash Kullanıcısını Güncelle',
      listOfProductAndServices: 'Ürün Ve Hizmet Listesi',
      goToStash: "Stash'e Git",
      wizard: 'Wizard',
      createStash: 'Stash Oluştur',
      stashName: 'Stash Adı',
      stashDescription: 'Stash Tanımı',
      stashInformation: 'Stash Bilgileri',
      setupYourStash: "Stash'ınızı Ayarlayın",
      setupYourStashInfo:
        'STASH tüm dosyalarınızı depolayabileceğiniz size özel, düzenli ve güvenli bulut alanıdır.',
      userInformation: 'Kullanıcı Bilgileri',
      setupYourUser: 'Kullanıcınızı Ayarlayın',
      setupYourUserInfo:
        'Panel üzerinden STASH alanınıza giriş yaparken kullanacağınız kullanıcı adı ve şifreyi belirleyin.',
      setupPackage: 'Kurulum',
      chooseYourPackage: 'Paket ve lokasyonunuzu seçin',
      confirmation: 'Onay',
      checkoutYourOrderAndConfirm: 'Siparişinizi kontrol edin ve onaylayın',
      createStashInfo:
        "Stash'le dilediğiniz kadar yeni alan oluşturabilirsiniz.",
      pluscloudsLabs:
        'PLUSCLOUDS LABORATUARLARI’NDA<br /><span style="color: #09c4f6;font-size: 30px;">ÖZENLE GELİŞTİRİLDİ</span>',
      storeAllFiles:
        "Mobil cihazınızdaki ve bilgisayarınızdaki tüm dosyaları Bulut'ta güvenle saklayın.",
      chooseAnotherUsername:
        'Bu kullanıcı adı kullanımda. Lütfen başka bir tane seçin.',
    },
  },
  datacenter: {
    dataCenterNode: 'Datacenter Node',
    nodes: 'Nodes',
  },
  forms: {
    vm: {
      name: 'Sanal Makine Adı',
      dcNode: 'Datacenter Node Seç',
      vmImage: "Sanal Makine Image'i Seç",
      catalog: 'Ürün Katalogu Seç',
      catalogTitle: 'Ürün Katalogu',
      network: 'Network Seç',
      basic: 'Basit Kurulum',
      expert: 'Uzman Kurulum',
      cpu: 'CPU Seçin',
      ram: 'RAM Seçin',
      overrideUsernameInfo:
        'Kullanıcı adını geçersiz kıl, sanal makinenin yönetici kullanıcısının kullanıcı adını gerçekten değiştirmez. Leo Veritabanındaki kullanıcı adı değerini değiştirir. Bu bilgiler, sanal makinenizin dışında çalışan otomasyon araçları tarafından kullanılmaktadır. Bu bilgi yanlışsa, otomasyon araçları otomatikleştirilmiş görevleri çalıştırmayabilir.',
      overridePasswordInfo:
        'Geçersiz kılma parolası, sanal makinenin yönetici kullanıcısının parolasını fiilen değiştirmez. Leo Veritabanındaki şifre değerini değiştirir. Bu bilgiler, sanal makinenizin dışında çalışan otomasyon araçları tarafından kullanılmaktadır. Bu bilgi yanlışsa, otomasyon araçları otomatikleştirilmiş görevleri çalıştırmayabilir.',
      convertToTemplateInfo:
        'Sanal makineyi bir şablona dönüştürmek, bu sanal makineyi PlusClouds ortamlarında klonlamanıza olanak tanır. Ancak bazı bulut düğümleri bir şablondan klonlamayı desteklemeyebilir.',
      convertToTemplateInfoFarm:
        '{0}, şablondan klonlamayı desteklemiyor. Bu şablonu küresel olarak kullanılabilir hale getirmek için lütfen desteğe danışın.',
      basicFormDisableInfo:
        'Seçtiğiniz datacenter node basit kurulumu desteklememektedir. Lütfen uzman kurulumu tercih ediniz.',
      expertFormDisableInfo:
        'Uzman kurulum yapılabilmesi için, datacenter node seçimi yapmanız gerekmektedir. Lütfen yukarıdan datacenter node seçin, sonrasında burası kullanımınıza açılacaktır.',
      vmHaltedInfoMessage:
        'Değişiklik yapmak için sunucu kapalı olmalıdır. Sunucuyu kapattıktan sonra güncelleme yapabilirsiniz.',
    },
    vd: {
      cloneFromTemplate: 'Şablondan Kopyala',
      storageVolume: 'Depolama Hacmi',
      info: 'Şimdi bir şablonun diskini klonluyorsunuz. Lütfen şablonların varsayılan bir parolayla geldiğinden emin olun; "template1!"<br><br>Şablon diskleri kullandığınızda, güvende olduğunuzdan emin olmak için <b>şifrenizi kendiniz sıfırlamanız</b> gerekir!',
    },
    ansible: {
      info: 'PlusClouds tarafından mükemmelleştirilen rolleri kullanarak kendi prosedürlerinizi ve otomasyon komut dosyalarınızı oluşturabilmeniz için bir Red Hat® Ansible Playbook oluşturun',
    },
    cloudsNodes: {
      nodeName: 'Cloud Node Adı',
      enterDatacenterForSearch: 'Veri Merkezi arayın',
    },
    streaming: {
      clusterName: 'Küme adı',
      serviceType: 'Servis Tipi',
      description: 'Tanım',
      incomingRouterIp: 'Gelen Yönlendirici IP',
      username: 'Kullanıcı adı',
      password: 'Şifre',
      dcNode: 'Datacenter Node',
      domain: 'Domain',
      streamName: 'Yayın Adı',
      streamDescription: 'Yayın Tanımı',
      streamType: 'Yayın Tipi',
      liveStream: 'Canlı Yayın',
      cluster: 'Küme',
    },
    ip: {
      selectNetworkCard: 'Select Network Card',
    },
  },
  examples: {
    domain: 'örnek : example.com',
    ip: 'örnek : 10.0.0.0',
    port: 'örnek : 443',
    number: 'örnek : 10',
  },
  dns: {
    infoTitle: 'DNS Hizmeti Özellikleri',
    alwaysONPluscloudsName: 'Always ON',
    alwaysONPlusclouds:
      "Plusclouds DNS Service, 5'ten fazla kıtada ve 15'ten fazla ülkedeki servis ağımız ile birlikte Global DNS çözümlemesine olanak tanıyarak benzersiz yedeklilik ve %100 uptime sağlar.",
    effectiveSecurityName: 'Etkili Güvenlik',
    effectiveSecurity:
      'Plusclouds DNS Service, uygulamalarınızın ve web servislerinizin her zaman DNS saldırılarından korunmasını sağlamak için tek tıklamayla DNSSEC hizmeti sunar.',
    highStableName: 'Yüksek ve Dengeli Performans',
    highStable:
      "Plusclouds DNS Service, ortalama 50 ms'lik DNS arama hızı ve 1 dakikadan daha kısa sürede dünya çapında DNS yayılımı sunan, dünyanın en hızlılarından biridir. Sıfır kesinti süresi ile DNS kayıtlarını yerleştirmeye ve yapılandırmaya yardımcı olur.",
    communityLink:
      'Daha fazla bilgi için <a target="_blank" href="https://plusclouds.com.tr/topluluk">Community</a> sayfamızı ziyaret edebilirsiniz.',
    alwaysON: 'ALWAYS ON',
    alwaysONContent:
      "Plusclouds DNS Service, 5'ten fazla kıtada ve 15'ten fazla ülkedeki servis ağımız ile birlikte Global DNS çözümlemesine olanak tanıyarak benzersiz yedeklilik ve %100 uptime sağlar.",
    effectiveSecurityTitle: 'ETKİLİ GÜVENLİK',
    effectiveSecurityContent:
      'Plusclouds DNS Service, uygulamalarınızın ve web servislerinizin her zaman DNS saldırılarından korunmasını sağlamak için tek tıklamayla DNSSEC hizmeti sunar.',
    highStableTitle: 'YÜKSEK VE DENGELİ PERFORMANS',
    highStableContent1:
      "Plusclouds DNS Service, ortalama 50 ms'lik DNS arama hızı ve 1 dakikadan daha kısa sürede dünya çapında DNS yayılımı sunan, dünyanın en hızlılarından biridir.",
    highStableContent2:
      'Sıfır kesinti süresi ile DNS kayıtlarını yerleştirmeye ve yapılandırmaya yardımcı olur.',
    working: 'Çalışıyor',
    notWorking: 'Çalışmıyor',
    enableDNSService: 'DNS servisini etkinleştir',
  },
  popups: {
    detachFromServer: {
      infoText1:
        "Tamam'a bastığınızda, eğer sunucunuz kapalı ise, disk'iniz sunucudan sökülecektir.",
      infoText2:
        'Diskinizi daha sonra dilediğiniz herhangi bir sunucuya bağlayabilirsiniz.',
      infoText3: 'Diskinizi sökmeniz diskinizin silineceği anlamına gelmez.',
      infoText4:
        'Diski söktükten sonra sunucunuzu silerseniz diskiniz silinmeyecektir.',
    },
  },
  productCatalog: {
    totalAmount: 'Toplam Tutar',
    vatIsNotIncluded: 'KDV hariç fiyattır.',
  },
  verification: {
    info: 'Sunucu kurabilmeniz için bazı onaylara ihtiyacımız var.',
    verifyEmail: 'Email adresinizi doğrulayın.',
    verifyGsm: 'GSM numaranızı doğrulayın.',
    verifyTC: 'TC Kimlik numaranızı doğrulayın.',
    confirmEmailInfoText:
      'Lütfen e-posta adresinize gönderdiğimiz kodu girerek e-postanızı etkinleştirin.',
    confirmEmailConfirmationCode: 'Onay kodu ulaşmadı mı?',
    tryAgain: 'Tekrar Dene',
    confirm: 'Onayla',
    confirmationCode: 'Onay kodu',
    sendConfirmationCode: 'Onay kodu gönder',
    saveAndSendConfirmationCode: 'Kaydet ve onay kodu gönder',
    pleaseEnterGSMNo: 'Lütfen GSM Numaranızı giriniz',
    verifyYourIdentityNumberInfoText:
      'Lütfen T.C. Kimlik numaranızı girerek hesabınızı onaylayın',
    confirmationCodeHasBeenSentMail: 'Onay kodu mail adresinize gönderildi.',
    goToLogin: 'Girişe git',
    second: 'saniye',
    beingRedirectedLoginScreen: 'Giriş ekranına yönlendiriliyorsunuz..',
    timeLeft: 'Kalan Süre',
    fullname: 'Ad Soyad',
    fullnameIsRequired: 'Ad Soyad Zorunlu',
    birthDateWithFormat: 'Doğum Tarihi (MM/DD/YYYY)',
    birthDateIsRequired: 'Doğum tarihi alanı zorunlu',
    birthDateRequiredFormat: 'Doğum tarihini ay/gün/yıl şeklinde giriniz.',
    identityNumber: 'T.C. Kimlik Numarası',
    identityIsRequired: 'TC Kimlik numaranız zorunlu',
    identityNumberConfirmed: 'TC Kimlik numaranız onaylandı.',
    identityNumberConfirmError:
      'TC Kimlik numaranız onaylanırken bir sorun oluştu.',
    invalidBirthDate: 'Doğum tarihi alanına geçersiz bir tarih girdiniz.',
    birthDataUpdateError:
      'Doğum tarihiniz güncellenirken bir sorun oluştu. İşleminize devam edilemiyor.',
    completeTheProcess: 'İşlemi Tamamla',
    confirmationCodeHasBeenSentPhone: 'Onay kodu telefonunuza gönderildi.',
    yourPhoneConfirmed: 'Telefon numaranız onaylandı.',
    yourPhoneConfirmError: 'Telefon numaranız onaylanırken bir sorun oluştu.',
    selectPhoneCode: 'Telefon kodu seçiniz',
    notTurkishCitizen: 'Türk vatandaşı değilim.',
  },
  scheduler: {
    scheduler: 'Zamanlayıcı',
    schedulerDetail: 'Zamanlayıcı Detayı',
    searchForScheduler: 'Zamanlayıcılar içinde ara',
    createNewScheduler: 'Yeni zamanlayıcı ekle',
    updateScheduler: 'Zamanlayıcıyı düzenle',
    name: 'Zamanlayıcı Adı',
    url: 'Url',
    method: 'Metod',
    schedule: 'Çalışma Zamanı',
    parameters: 'Parametreler',
    headers: 'Headers',
    headersAndParameters: 'Headers & Parametreler',
    enabled: {
      true: 'Aktif',
      false: 'Pasif',
    },
    isEnable: 'Aktif mi?',
    runManually: 'Manuel Çalıştır',
    setScheduler: 'Zamanlayıcıyı Ayarla',
    manage: 'Yönet',
    preview: 'Önizleme',
    body: 'İçerik',
    header: 'Header',
    response: 'Yanıt',
    enterVariable: 'Değişken girin',
    enterValue: 'Değer girin',
    addNewVariable: 'Değişken ekle',
    clickSubmitToSeeResult: "Sonucu görmek için gönder'e basınız.",
    cronExpression: 'Cron ifadesi:',
  },
  time: {
    minute: 'Dakika',
    hourly: 'Saatlik',
    daily: 'Günlük',
    weekly: 'Haftalık',
    weekday: 'Hafta Günü',
    monthly: 'Aylık',
    yearly: 'Yıllık',
    '2yearly': '2 Yıllık',
    '3yearly': '3 Yıllık',
    '4yearly': '4 Yıllık',
    '5yearly': '5 Yıllık',
    once: 'Bir Kere',
    everyMinute: 'Her dakika',
    evenMinutes: 'Çift dakikalar',
    oddMinutes: 'Tek dakikalar',
    every5Minutes: 'Her 5 dakikada bir',
    every15Minutes: 'Her 15 dakikada bir',
    every30Minutes: 'Her 30 dakikada bir',
    everyHour: 'Her saat',
    evenHours: 'Çift saatler',
    oddHours: 'Tek saatler',
    every6Hours: 'Her 6 saatte bir',
    every12Hours: 'Her 12 saatte bir',
    everyDay: 'Hergün',
    evenDays: 'Tek günler',
    oddDays: 'Çift günler',
    every5Days: 'Her 5 günde bir',
    every10Days: 'Her 10 günde bir',
    everyHalfMonth: 'Her ayın ortası',
    everyMonth: 'Her ay',
    evenMonths: 'Tek aylar',
    oddMonths: 'Çift aylar',
    every10Months: 'Her 10 ayda bir',
    everyHalfYear: 'Her yılın ortası',
    everyWeekday: 'Her gün',
    mondayToFriday: 'Pazartesi - Cuma',
    weekendDays: 'Haftasonu günleri',
    midnight: 'Gece yarısı',
    noon: 'öğlen',
    am: 'öö',
    pm: 'ös',
  },
  weekday: {
    0: 'Pazar',
    1: 'Pazartesi',
    2: 'Salı',
    3: 'Çarşamba',
    4: 'Perşembe',
    5: 'Cuma',
    6: 'Cumartesi',
  },
  month: {
    1: 'Ocak',
    2: 'Şubat',
    3: 'Mart',
    4: 'Nisan',
    5: 'Mayıs',
    6: 'Haziran',
    7: 'Temmuz',
    8: 'Ağustos',
    9: 'Eylül',
    10: 'Ekim',
    11: 'Kasım',
    12: 'Aralık',
  },
  shortDay: {
    mon: 'Pzt',
    tue: 'Sal',
    wed: 'Çar',
    thu: 'Per',
    fri: 'Cum',
    sat: 'Cmt',
    sun: 'Pzr',
  },
  gateways: {
    gateways: 'Ağ Geçitleri',
    gatewaysDetail: 'Ağ Geçit Detayı',
    createNewGateway: 'Yeni Ağ Geçidi Yarat',
    updateGateway: 'Ağ Geçidi Düzenle',
    searchForGateway: 'Ağ geçici ara',
    publicNetwork: 'Genel Ağ',
    privateNetwork: 'Özel Ağ',
    failedToFetchVMDetail: 'Sanal makine detayı getirilemedi.',
    activate: 'Aktif et',
    vpnPassive: 'VPN Servisi Pasif',
    enableVpnInfo:
      'Bu alanı görmek için VPN Servisini aktifleştirmeniz gerekir.',
    natRecordPassive: 'NAT Servisi Pasif',
    enableNatInfo:
      'Bu alanı görmek için NAT Servisini aktifleştirmeniz gerekir.',
    proxyRecordPassive: 'Proxy Servisi Pasif',
    enableProxyInfo:
      'Bu alanı görmek için Proxy Servisini aktifleştirmeniz gerekir.',
    dhcpRecordPassive: 'DHCP Servisi Pasif',
    dhcpRecordActive: 'DHCP Servisi Aktif',
    enableDHCPInfo:
      'Bu alanı görmek için DHCP Servisini aktifleştirmeniz gerekir.',
    ntpRecordPassive: 'NTP Servisi Pasif',
    enableNTPInfo:
      'Bu alanı görmek için NTP Servisini aktifleştirmeniz gerekir.',
    loadBalancerRecordPassive: 'Load Balancer Servisi Pasif',
    enableLoadBalancerInfo:
      'Bu alanı görmek için Load Balancer Servisini aktifleştirmeniz gerekir.',
    vpnRecordPassive: 'VPN Servisi Pasif',
    is_connected: 'Bağlı mı?',
    is_connection_secure: 'Bağlantı güvenli mi?',
    is_usable: 'Kullanılabilir mi?',
    nodes: 'Nodes',
    enterNode: 'Node Girin',
    domainName: 'Alan Adı',
    balancingMethod: 'Dengeleme Yöntemi',
    createProxyHostRecord: 'Proxy Host Kaydı Oluştur',
    createLoadBalanceHostRecord: 'Load Balance Kaydı Oluştur',
    createVpnClientRecord: 'VPN İstemci Kaydı Oluştur',
    pools: 'Pools',
    timezone: 'Saat Dilimi',
    ntpService: 'NTP Servisi',
    enterDomain: 'Domain Girin',
    enableVpnService: 'VPN Servisini Aktifleştir',
    mode: 'Mod',
    isTlsServer: 'TLS Sunucusu mu?',
    dev: 'Dev',
    keepAlive: 'Canlı tut',
    deleteVpnConfig: 'VPN Ayarlarını Sil',
  },
  password: {
    score: 'Skor',
    fair: 'Zayıf',
    good: 'İyi',
    veryStrong: 'Mükemmel',
    eightCharactersMinimum: 'Minimum 8 karakter',
    oneUpper: '1 büyük harf',
    oneLower: '1 küçük harf',
    oneNumber: 'Bir sayı',
    oneSpecialCharacter: 'Bir özel karakter',
  },
  communication: {
    communication: 'İletişim',
    communicationChannels: 'İletişim Kanalları',
    newsChannels: 'Haber Kanalları',
    newsListInfo: 'Kayıtlı olduğunuz haber kanalları aşağıda listelenmektedir.',
    emailRecordsCannotBeDeleted: 'Email kayıtları silinemez.',
    createNewChannel: 'Yeni Kanal',
    form: {
      channelType: 'Kanal Tipi',
      webhookUrl: 'Webhook Adresi',
      passcode: 'Kod',
      codeInfo:
        'Webhook adresini doğrulamak için size gelen kodu aşağıya girmeniz gerekmektedir.',
    },
  },
  list: {
    noRecordInfoLine1: 'Henüz eklenmiş bir kaydınız yok.',
    noRecordInfoLine2: 'Kaydınızı oluşturun ve hemen kullanmaya başlayın!',
    noRecordInfoLine1ForSearch: 'Aramanıza uygun bir kayıt bulamadık.',
    addNew: 'Yeni Ekle',
    clearFilters: 'Filtreleri Temizle',
  },
  registry: {
    plusCloudsRegistry: 'PlusClouds Registry',
    createNewRepository: 'Yeni Depo Oluştur',
    updateRepository: 'Depo Güncelle',
    lastHash: 'Son Şifrelenme',
    imageList: 'Imaj Listesi',
  },
  plusCloudsCs: {
    advertiseAddr: 'Advertise Address',
    listenAddr: 'Listen Address',
    managerCount: 'Manager Count',
    networkCount: 'Network Count',
    runningReplicaCount: 'Running Replica Count',
    workerCount: 'Worker Count',
    createServiceManagement: 'Service Management Oluştur',
  },
  giftcode: {
    giftcode: 'Kupon Kodu',
    useGiftCode: 'Kupon Kodu Kullan',
    giftcodes: 'Kuponlarım',
    addnewcode: 'Yeni Kod Ekle',
    newCodeInfo:
      'İndirim kodunuzu girip, size özel indirimlerden faydalanabilirsiniz.',
    useCode: 'Kodu Kullan',
    code: 'Kod',
    discount: 'İndirim',
    discountProductInformation: 'İndirimli Ürün Bilgileri',
    notFound: 'Girilen koda ait bir indirim bulunamadı.',
    codeUsedBefore: 'Girilen kod daha önceden kullanılmış.',
    checkCode: 'Kodu kontrol et',
    product: 'Ürün',
    isUsed: 'Kullanılmış mı?',
    cancelCode: 'Kodu iptal et',
  },
  iam: {
    plusCloudsIAM: 'IAM',
    plusCloudsIAMDetail: 'IAM Detayı',
    createNewIAMService: 'Yeni IAM Servisi Oluştur',
    updateIAMService: 'IAM Servisini Güncelle',
    ldap_server_name: 'LDAP Sunucu Adı',
    ldap_server_name_placeholder: 'LDAP Test',
    ldap_server_url: 'LDAP Sunucu Url',
    ldap_server_url_placeholder: '10.100.10.1',
    ldap_server_port: 'LDAP Sunucu Portu',
    ldap_server_port_placeholder: '389',
    ldap_base_dn: 'LDAP Base DN',
    ldap_base_dn_placeholder: 'dc=plusclouds,dc=com',
    ldap_bind_username: 'LDAP Kullanıcı Adı',
    ldap_bind_username_placeholder: 'cn=admin,dc=plusclouds,dc=com',
    ldap_bind_password: 'LDAP Şifresi',
    default_filter: 'Varsayılan Filtre',
    default_filter_placeholder: '(objectclass=*)',
    default_memberof: 'Varsayılan Üyelik',
    default_group: 'Varsayılan Grup',
    default_userid_field: 'Varsayılan Kullanıcı Id Alanı',
    default_userid_field_placeholder: 'uid',
    default_password_field: 'Varsayılan Şifre Alanı',
    default_email_field: 'Varsayılan Email Alanı',
    default_alias_field: 'Varsayılan Alias Alanı',
    default_alias_field_placeholder: 'cn',
    default_first_name_field: 'Varsayılan İsim Alanı',
    default_last_name_field: 'Varsayılan Soyisim Alanı',
    default_last_name_field_placeholder: 'sn',
    people: 'Kişiler',
    groups: 'Gruplar',
    createNewPerson: 'Yeni Kişi Oluştur',
    updatePerson: 'Kişi Güncelle',
    createNewGroup: 'Yeni Grup Oluştur',
    updateGroup: 'Grup Güncelle',
    givenname: 'Verilen Ad',
    cn: 'Ad.Soyad (cn)',
    sn: 'Soyad (sn)',
    uid: 'Kullanıcı Adı (uid)',
    homedirectory: 'Ana Klasör',
    loginshell: 'Login Shell',
  },
  account: {
    overview: 'Genel Bakış',
    settings: 'Ayarlar',
    informationVerification: 'Profil Doğrulama',
    emailNotValidated: 'Email doğrulanmadı',
    phoneNotValidated: 'Telefon numarası doğrulanmadı',
    ninNotValidated: 'Kimlik doğrulanmadı',
    emailValidated: 'Email doğrulanmış',
    phoneValidated: 'Telefon numarası doğrulanmış',
    ninValidated: 'Kimlik doğrulanmış',
    memberSince: 'Kayıt tarihi',
    fullName: 'Adı Soyadı',
    about: 'Hakkında',
    gender: 'Cinsiyet',
    birthday: 'Doğum Tarihi',
    phone: 'Telefon',
    country: 'Ülke',
    accountType: 'Hesap Tipi',
    roles: 'Roller',
    profileDetails: 'Profil Detayları',
    contactMe: 'Bana Ulaşın',
    customerRepresentative: 'Müşteri Temsilciniz',
    customerRepresentativeName: 'Dilara Ödemiş',
    contactSalesConsultant: 'Satış Danışmanıyla İletişime Geçin',
    salesConsultant: 'Satış Danışmanı',
    salesConsultantMessage:
      'Size daha iyi hizmet verebilmemiz için bize ulaşmak istediğiniz konuyla ilgili bilgi verebilir misiniz?',
    from: 'Kimden',
    to: 'Kime',
    updatePassword: 'Şifre Güncelle',
    updateEmail: 'E-Mail Güncelle',
    updatePhone: 'Telefon Güncelle',
    updateCurrency: 'Para Birimi Güncelle',
    updateCurrencyTitle: 'Para birimi değiştirme talebi',
    updateCurrencyDescription:
      'Sayın yetkili, sistemde kullandığım ana para birimini aşağıdaki gibi değiştirmek istiyorum. Yardımcı olursanız sevinirim.',
    phoneCode: 'Telefon Kodu',
    support: 'Destek',
    payment: 'Ödeme',
    addresses: 'Adresler',
    isInvoiceAddress: 'Fatura Adresi Mi?',
    addressName: 'Adres Adı',
    address: 'Adres',
    createNewAddress: 'Yeni Adres Oluştur',
    updateAddress: 'Adres Güncelle',
    state: 'İlçe',
    postCode: 'Posta Kodu',
    addressLine1: 'Adres Satırı 1',
    addressLine2: 'Adres Satırı 2',
    searchSupportTicket: 'Destek talebi ara',
    newSupportTicket: 'Destek talebi oluştur',
    ticketNumber: 'Talep Numarası',
    searchForTicketNumber: 'Talep Numarasına göre ara',
    newTicketAlert: 'Yeni destek talebi geldi!',
    subject: 'Konu',
    message: 'Mesaj',
    closeTicket: 'Talebi Kapat',
    writeSomething: 'Birşeyler yazın',
    writeReplyOrDragFilesHere: 'Cevabınızı yazın yada dosyayı buraya bırakın',
  },
  accountType: {
    Individual: 'Kişisel Hesap',
    Corporate: 'Kurumsal Hesap',
    Association: 'Dernek Hesabı',
    K12: 'Okul veya Kolej',
    University: 'Üniversite',
    NPO: 'Kâr Amacı Olmayan Hesap',
    NGO: 'Devlet Dışı Hesap',
    Team: 'Takım Hesabı',
  },
  gender: {
    male: 'Erkek',
    female: 'Kadın',
  },
  errors: {
    notEmpty: 'Bu alan boş bırakılamaz.',
    minLenght: 'En az {0} karakter olmalıdır.',
    maxLenght: 'En fazla {0} karakter olmalıdır..',
  },
  alert: {
    moduleUnderMaintenance:
      'Bu modül şu anda bakımdadır. Bakım işlemi bittikten sonra kullanmaya devam edebilirsiniz.',
    useSupport:
      'Size daha iyi hizmet verebilmek, hizmet sürekliliğini takip edebilmek ve teknik sorunlarınızı doğrudan ekibimize iletebilmemiz adına lütfen sol tarafta bulunan <a href="/support" class="text-warning">destek alanı</a>ndan destek talebinde bulunun.',
  },
  token: {
    personalAccessTokens: 'Kişisel Erişim Anahtarları',
    personalAccessToken: 'Kişisel Erişim Anahtarı',
    expireDate: 'Son Kullanma Tarihi',
    recordNo: 'Kayıt No',
    addNewToken: 'Yeni Anahtar Oluştur',
    tokenSuccessResult:
      'İşlemlerinizde kullanabileceğiniz anahtar bilgileri aşağıda paylaşılmaktadır. Lütfen bilgileri kaydediniz.',
  },
}
